export default {
  label: 'Discută cu echipa noastră',
  label_unread: 'Discută cu echipa noastră, {{count}} noi',
};
